module.exports = __webpack_public_path__ + "img/pethouse43.b72d2a14.jpg";